import React from 'react'
import {useQuery} from 'react-query'
import {QUERIES} from '../../../_metronic/helpers'
import {locationsApi} from '../../../_metronic/helpers/custom/api/locationsApi'
import {Warehouse} from './Warehouse'
import {useIntl} from 'react-intl'

const WarehousesList = () => {
  const intl = useIntl()
  useQuery([QUERIES.COUNTRY_ABBR_LIST, intl.locale], locationsApi.fetchDirectionCountriesList)

  return <Warehouse />
}

export default WarehousesList
